<dialog
  #dialog
  qai-dialog
  [heading]="heading"
  [description]="subheading"
  [showClose]="true"
  (closeButtonClicked)="close()"
  (click)="onBackdropClick($event)"
>
  <div class="list-modal-content">
    <ng-content></ng-content>
  </div>
</dialog>
